<section class="user-detail-page">

  @if (loader()) {
    <div class="loader-wrap">
      <app-spinner-loader [width]="40" />
    </div>
  } @else if (user; as u) {

    <a class="back-link" (click)="goBack()">
      <i class="pi pi-arrow-left"></i> Back to Users
    </a>

    <!-- Page Title -->
    <div class="page-header">
      <h3 class="page-title mb-0">User Details</h3>
    </div>

    <!-- Main Card -->
    <div class="detail-card">

      <!-- Profile Header -->
      <div class="profile-header">
        <div class="profile-row">
          <div class="avatar-wrap">
            <div class="avatar-circle">
              <!-- Show image if exists -->
              @if (u.image) {
                <img [src]="u.image" alt="User Image" class="avatar-photo-img" (error)="u.image = null" />
              } @else {
                <i class="pi pi-user avatar-icon"></i>
              }
            </div>
          </div>
          <div class="profile-info">
            <h4 class="user-name mb-1">{{ u.name }} </h4>
            <p class="user-email mb-2">{{ u.email }}</p>
            <div class="meta-row">
              <span class="meta-item">
                <i class="pi pi-calendar me-1"></i>
                Joined: {{ u.joinDate }}
              </span>
              <span class="meta-item">
                <i class="pi pi-clock me-1"></i>
                Last active: {{ u.lastActive }}
              </span>
            </div>
          </div>
          <span class="status-badge" [ngClass]="{
            'active': u.status === 'Active',
            'inactive': u.status === 'Inactive',
            'banned': u.status === 'Banned'
          }">
            {{ u.status }}
          </span>
        </div>
      </div>

      <!-- Stats Row -->
      <div class="stats-row">
        <div class="stat-card">
          <div class="stat-card-left">
            <p class="stat-label mb-1">Parties Attended</p>
            <h2 class="stat-value mb-1">{{ u.partiesAttended }}</h2>
          </div>
          <div class="stat-icon-wrap">
            <i class="pi pi-user stat-icon"></i>
          </div>
        </div>

        <div class="stat-card">
          <div class="stat-card-left">
            <p class="stat-label mb-1">Total Points</p>
            <h2 class="stat-value mb-1">{{ u.totalPoints | number }}</h2>
          </div>
          <div class="stat-icon-wrap">
            <i class="pi pi-star-fill stat-icon"></i>
          </div>
        </div>
      </div>

      <!-- Recent Activity -->
      <div class="activity-section">
        <h5 class="section-title">Recent Activity</h5>
        <div class="activity-list">
          @for (item of activities; track $index) {
            <div class="activity-item">
              <div class="activity-content">
                <p class="activity-title mb-0">{{ item.title }}</p>
                <p class="activity-desc mb-0">{{ item.type }}</p>
                <p class="activity-date mb-0">{{ item.rawTime }}</p>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="action-row">
        <!-- Ban / Unban -->
        <button [disabled]="isBanLoading()" [ngClass]="u.status === 'Active' ? 'btn-ban' : 'btn-success'"
          (click)="toggleUserStatus()">
          @if (!isBanLoading()) {
            <i class="pi" [ngClass]="u.status === 'Active' ? 'pi-ban' : 'pi-check'"></i>
          } @else {
            <i class="pi pi-spin pi-spinner"></i>
          }

          {{ isBanLoading()
            ? 'Processing...'
            : (u.status === 'Active' ? 'Ban User' : 'Unban User') }}
        </button>

        <!-- Delete -->
        <button class="btn-delete" [disabled]="isDeleteLoading()" (click)="deleteUser()">
          @if (!isDeleteLoading()) {
            <i class="pi pi-trash me-2"></i>
          } @else {
            <i class="pi pi-spin pi-spinner me-2"></i>
          }

          {{ isDeleteLoading() ? 'Deleting...' : 'Delete Account' }}
        </button>
      </div>

    </div>
  }
</section>